class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      typeof infinitescroll == "object" && typeof infinitescroll?.scolljs == "function" && infinitescroll?.scolljs();
      document.querySelector('body').classList.remove('open-filter');
      if($(window).width()<992){
        $(".collection-filter").animate({ scrollTop: 0 },0);
      }
    }, 500);
    // if($(window).width()>992){
    //   this.querySelector("form").addEventListener("input",this.debouncedOnSubmit.bind(this));    
    // }
    // else{
      const applyfilter = this.querySelector('.apply-filter');
      if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));      
    //}    
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderActiveFilter(html);
        typeof infinitescroll == "object" &&
          typeof infinitescroll?.scolljs == "function" &&
          infinitescroll?.scolljs();
        if (typeof quickAddButton == "function") {
          quickAddButton();
        }
      });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderActiveFilter(html);
    if (typeof quickAddButton == "function") {
      quickAddButton();
    }
  }
  static renderProductGridContainer(html) {
    document.getElementById("main-collection-product-grid").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("main-collection-product-grid").innerHTML;
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll(".filter-index");
    const matchesIndex = (element) => {
      const jsFilter = event
        ? event.target.closest(".filter-index")
        : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    facetsToRender.forEach((element) => {
      document.querySelector(
        `.filter-index[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });
     rangePrice();
  }
  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }
  static getSections() {
    return [
      {
        section: document.getElementById("main-collection-product-grid").dataset.id,
      },
    ];
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }
  onActiveFilterClick(event) {
    event.preventDefault();    
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();
/*function filterprice() {
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    var _this = inputLeft,
      min = parseInt(_this.min),
      max = parseInt(_this.max);
    _this.value = Math.min(
      parseInt(_this.value),
      parseInt(inputRight.value) - 1
    );
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    amountLeft.innerHTML = _this.value;
    range.style.left = percent + "%";
  }
  setLeftValue();
  function setRightValue() {
    var _this = inputRight,
      min = parseInt(_this.min),
      max = parseInt(_this.max);   
    _this.value = Math.max(
      parseInt(_this.value),
      parseInt(inputLeft.value) + 1
    );
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = 100 - percent + "%";
    var rightvals = parseInt(_this.value) + 1;
    amountRight.innerHTML = _this.value;
    range.style.right = 100 - percent + "%";
    _this.style.zIndex = 3;
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
}*/
function rangePrice(params) {
  var lowerSlider = document.querySelector('#lower'),
   upperSlider = document.querySelector('#upper'),
   lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);
    upperSlider.oninput = function() {
       lowerVal = parseInt(lowerSlider.value);
       upperVal = parseInt(upperSlider.value);
      document.querySelector('.prevtsetval').value = lowerVal;
      document.querySelector('.nextsetval').value = upperVal;
       if (upperVal < lowerVal + 0) {
          lowerSlider.value = upperVal - 0;
          if (lowerVal == lowerSlider.min) {
             upperSlider.value = 0;
          }
       }  
      var widthFinal1 = (this.value - lowerSlider.value) / upperSlider.max * 100;
      var widthFinal = widthFinal1 + "%";
      var MarginLeft = lowerSlider.value / upperSlider.max * 100 + "%";
      document.querySelectorAll('.default_item_rang').forEach(function(e){
        e.style.maxWidth = widthFinal;
        e.style.marginLeft = MarginLeft;
      })
      if(widthFinal1 < 99){
         var numOfSelected = $('.filter-box .filterlist li input:checked').length + 1;
        $('.aply_filter').text($('.aply_filter').data('text').trim() + ' (' + numOfSelected + ')');
      }
      else{
        var numOfSelected = $('.filter-box .filterlist li input:checked').length;
        if(numOfSelected>=0){
          $('.aply_filter').text($('.aply_filter').data('text').trim() + ' (' + numOfSelected + ')');
        }
        else{
          $('.aply_filter').text($('.aply_filter').text().trim());
        }
      }
    };
    lowerSlider.oninput = function() {
      lowerVal = parseInt(lowerSlider.value);
      upperVal = parseInt(upperSlider.value);
      document.querySelector('.prevtsetval').value = lowerVal;
      document.querySelector('.nextsetval').value = upperVal;
       if (lowerVal > upperVal - 0) {
          upperSlider.value = lowerVal + 0;        
          if (upperVal == upperSlider.max) {
             lowerSlider.value = parseInt(upperSlider.max) - 0;
          }
       }
       var widthFinal1 = (upperSlider.value - this.value) / upperSlider.max * 100;
      var widthFinal = widthFinal1 + "%";
      var MarginLeft = this.value / upperSlider.max * 100 + "%";
      document.querySelectorAll('.default_item_rang').forEach(function(e){
        e.style.maxWidth = widthFinal;
        e.style.marginLeft = MarginLeft;
      })
        if(widthFinal1 < 99){
         var numOfSelected = $('.filter-box .filterlist li input:checked').length + 1;
        $('.aply_filter').text($('.aply_filter').data('text').trim() + ' (' + numOfSelected + ')');
      }
      else{
        var numOfSelected = $('.filter-box .filterlist li input:checked').length;
        if(numOfSelected>=0){
          $('.aply_filter').text($('.aply_filter').data('text').trim() + ' (' + numOfSelected + ')');
        }
        else{
          $('.aply_filter').text($('.aply_filter').text().trim());
        }
      }
      // const input_background = (lowerVal - lowerSlider.min) / (lowerSlider.max - lowerSlider.min)*100;
      // lowerSlider.style.background = 'linear-gradient(to right, #A5A5A5 0%, #A5A5A5 ' + input_background + '%, #000000 ' + input_background + '%, #000000 100%)'
    };
   var eventList = ["change", "keyup"];
    for(event of eventList) {
      EventFunction(event,'.prevtsetval','.price-left')
      EventFunction(event,'.nextsetval','.price-right')
    }
}
const EventFunction = (event,eventer,targetClass) => {
  document.querySelector(eventer).addEventListener(event, function(e) {
      e.preventDefault();
     document.querySelector(targetClass).value = e.target.value;
      rangePrice();
  });
}
if (document.querySelector(".rangecls")) {
  rangePrice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect() {
  let userAgent = navigator.userAgent;
  let browserName;
  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "no-browser";
  }
  document.getElementById("MainContent").classList.add(browserName);
}
fnBrowserDetect();

//this script loops through the filter elements and ensures that only the sort by filter is open, the rest of the filters are closed by default on desktop
 

if(window.innerWidth <= 991) {
  $(document).on("click", ".filter_title", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).next(".filterlist,.rangeclswrap").slideToggle();
  });
}

$(document).on('click','.filterbtn',function (e) {
  e.preventDefault();
  $('body').toggleClass('open-filter');
    // $('.filter_panel').css('transform','translate(0%)');
  
});
$(document).on('click','.filter-close',function (e) {
  console.log('123');
  e.preventDefault();
  const form = document.querySelector('facet-filters-form');
  form.onActiveFilterClick(e);
  // $('.filter_panel').css('transform','translate(100%)');
  // setTimeout(function() {
    $('body').removeClass('open-filter');
  // }, 2000);
  
});

$(document).ready(function(){
  $(document).on('click','.filter-box .filterlist li',function(){
    var numOfSelected = $('.filter-box .filterlist li input:checked').length;
      if(numOfSelected>=0){
        $('.aply_filter').text($('.aply_filter').data('text').trim() + ' (' + numOfSelected + ')');
      }else{
        $('.aply_filter').text($('.aply_filter').text().trim());
      }
  });
  // $(document).on('click','.filter-box .filterlist li',function(){
  //   var numOfSelected = $('.filter-box .filterlist li input:checked').length;
  //     if(numOfSelected>0){
  //       $('.filter_button').text($('.filter_button').data('text').trim() + ' (' + numOfSelected + ')');
  //     }else{
  //       $('.filter_button').text($('.filter_button').text().trim());
  //     }
  // });
});

// $('.facet-list').each(function() {
//   $('.facet-list input').change(function () {
//     var length = $(this).closest('.facet-list').find('input:checked').length;
//     console.log(length);
//     $(this).closest('.facet-list').find('.mob-count').text('(' + length + ')')
//   });
// });


$(document).ready(function() {
  function updateCount(facetList) {
    var length = facetList.find('input:checked').length;
    console.log(length)
    var mobCountDiv = facetList.find('.mob-count');
    var divv = facetList.find('.filter_title');
    if (length === 0) {
      mobCountDiv.addClass('hide');
      divv.removeClass('font-700');
    //  $('.filter-bottom').css('display', 'none');
    } else {
      mobCountDiv.text('(' + length + ')').removeClass('hide');
      divv.addClass('font-700');
    //  $('.filter-bottom').css('display', 'flex');
    }
  }

  $('.facet-list').each(function() {
    var facetList = $(this);
    facetList.find('input').change(function() {
      updateCount(facetList);
    });
    updateCount(facetList);
  });


    var lan = $(this).find('input:checked').length;
    console.log(lan,'=====')
    if (lan > 0) {
   //   $('.filter-bottom').css('display', 'flex');
    }else{
  //    $('.filter-bottom').css('display', 'none');
    }
  
});






